<script>
import { _ } from "svelte-i18n";

import { Link} from "svelte-navigator";

export let title;
export let base;

export function getValues(base) {
  console.log('foo')
  const oneToNine = Array(9).fill('').map((_, index) => index + 1);

  if (!base) {
    return oneToNine;
  }

  return oneToNine.map((num) => {
    return parseFloat(base) % 1 === 0 ? `${base}.${num}` : `${base}${num}`;
  })
}
</script>

<div class="links">
  <h3 class="links-header">{title}</h3>
  <ul>
    {#each getValues(base) as value}
      <li class="link"><Link to="/m/{value}">{$_('meters.howManyInches', {values: {meter: value}})}</Link></li>
    {/each}
  </ul>
</div>